import { Cloud, Cpu, Database, Flame, Server, Smartphone, type LucideIcon } from "lucide-react";

export interface TechStackItem {
  /** Real technology name, shown as text — no fetched/trademarked logo image, see this module's comment. */
  icon: LucideIcon;
  name: string;
  reason: string;
  usage: string;
}

// Real logo marks for Flutter/Firebase/GCP/etc. are trademarked brand
// assets ZenFresh has no license to display, and this repo has no vetted
// copy of them to use. Generic lucide-react icons stand in for each
// technology instead — the real name and reason are still shown as text,
// nothing here is fabricated, just not wearing someone else's logo.
export const TECH_STACK: TechStackItem[] = [
  {
    icon: Smartphone,
    name: "Flutter",
    reason: "One codebase, native performance on both iOS and Android.",
    usage: "Powers the Customer App and Driver App, so feature parity across platforms ships from a single codebase.",
  },
  {
    icon: Server,
    name: "FastAPI",
    reason: "High-throughput, async-first Python for latency-sensitive endpoints.",
    usage: "Serves the order, tracking, and catch-declaration APIs that both apps and the Admin Command Centre depend on.",
  },
  {
    icon: Flame,
    name: "Firebase",
    reason: "Real-time sync and managed auth without standing up custom infrastructure.",
    usage: "Handles live order status updates and driver location sync between the Driver App and Customer App.",
  },
  {
    icon: Cloud,
    name: "Google Cloud Platform",
    reason: "Managed, scalable infrastructure for a network that grows city by city.",
    usage: "Hosts the backend services and object storage behind every ZenFresh product.",
  },
  {
    icon: Cpu,
    name: "Vertex AI",
    reason: "Managed ML pipelines without a dedicated ML infrastructure team.",
    usage: "Powers freshness-based product recommendations and demand forecasting in the Admin Command Centre.",
  },
  {
    icon: Database,
    name: "BigQuery",
    reason: "Fast analytical queries over the full order and catch-traceability history.",
    usage: "Backs the KPI dashboards and supplier scorecards with historical, queryable data.",
  },
];
